function getNotificationHandler() {
    var _listeners = [];
    return {
        /**
         * Fires an event to its listeners
         * @param args - The parameters of the event
         */
        fireEvent: function (args) {
            _listeners.forEach(function (listener) { return listener(args); });
        },
        /**
         * Add an event listener
         * @param listener - The listener that can process events
         */
        addListener: function (listener) {
            if (listener) {
                _listeners.push(listener);
            }
        }
    };
}
var notificationHandler = getNotificationHandler();
/**
 * Returns a list of notification event listeners. You can add an event listener:
 *    onNotification().addListener(event =\> \{
 *      console.log(event!.message + ' ' + event!.level); \});
 *
 * DO NOT trigger telemetry events on these notifications, as doing so may
 * create an infinite loop of telemetry events.
 */
export function onNotification() {
    return notificationHandler;
}
/**
 * Internal function: log a notification
 * @param level - The level of notification to log
 * @param category - The category of the notification
 * @param message - A function that returns a message to log
 */
export function logNotification(level, category, message) {
    notificationHandler.fireEvent({ level: level, category: category, message: message });
}
/**
 * Internal function: log an error
 * @param category - The category of the notification
 * @param message - A message that will precede the message from error object
 * @param error - An error object, from which an error message might be obtained
 */
export function logError(category, message, error) {
    logNotification(0 /* LogLevel.Error */, category, function () {
        var errorMessage = error instanceof Error ? error.message : '';
        return "".concat(message, ": ").concat(errorMessage);
    });
}
//# sourceMappingURL=OTelNotifications.js.map